<template>
  <div class="left_side">
        <!-- <div class="back_return" v-if="outLineKey" @click="goOutline">返回到概览分析</div> -->
        <v-expansion-panels accordion v-model="activeKey">
          <!-- multiple -->
          <v-expansion-panel v-for="item in defauleSearchSchema.defaultFilter"  :key="item.key">
            <v-expansion-panel-header>{{item.label}}</v-expansion-panel-header>
            <v-expansion-panel-content v-if="item.key !='other'">
                  <div>
                    <v-list>
                        <v-list-item-group
                            v-model="selectedItem[item.key]"
                            color="primary"
                            >
                            <v-list-item :class="{'v-list-item--active1': b.key == outLineKey}" v-for="b in getSavedSearchSchema(item.key)" :key="b.key" :value="b.key" @click="goAnalysis(item.key,b)">
                                <v-list-item-content>
                                    <v-list-item-title :title="b.label">
                                      <v-icon class="blue1" v-if="b.default == 'lineChart'">mdi-chart-line</v-icon>
                                      <v-icon class="green1" v-if="b.default == 'barChart'">mdi-chart-bar</v-icon>
                                      <v-icon class="yellow1" v-if="b.default == 'pieChart'">mdi-chart-arc</v-icon>
                                      {{ b.label }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                  </div>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-else>
                  <div>
                    <v-list>
                        <v-list-item-group
                            v-model="selectedItem[item.key]"
                            color="primary"
                            >
                            <v-list-item :class="{'v-list-item--active': b.key == outLineKey}" v-for="b in getSavedSearchSchema(item.key)" :key="b.key" :value="b.key">
                                <v-list-item-content>
                                    <v-list-item-title :title="b.label">
                                      <div class="flex_style betw">
                                        <div>
                                          <v-icon class="blue1" v-if="b.default == 'lineChart'">mdi-chart-line</v-icon>
                                          <v-icon class="green1" v-if="b.default == 'barChart'">mdi-chart-bar</v-icon>
                                          <v-icon class="yellow1" v-if="b.default == 'pieChart'">mdi-chart-arc</v-icon>
                                          <span @click="goAnalysis(item.key,b)" class="tit_overflow" style="display: inline-block;width: auto;">{{ b.label }}</span>  
                                        </div>
                                        <div>
                                          <v-icon @click="editItem(b)">mdi-grease-pencil</v-icon>  <v-icon @click="delItem(b)">mdi-delete</v-icon>
                                        </div>
                                      </div>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                  </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-btn class="custom_btn_wrapper" @click="openCustom">自定义分析</v-btn>
      <v-dialog v-model="customDialog" width="60%">
        <v-card class="country_dialog">
          <v-card-title class="headline lighten-2">自定义分析</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="addSpace_wrapper">
                <div class="padlg">
                  <div class="margbsm"><span class="common_title">名称</span></div>
                  <div class="common_input_style margbsm">
                    <v-text-field
                    label=""
                    hide-details
                    outlined
                    v-model="customName"
                    ></v-text-field>
                  </div>
                  <!-- <div class="margbsm"><span class="common_title">分组</span></div>
                  <div class="common_input_style margbsm">
                    <v-select
                        v-model="sItemGroup"
                        :items="defauleSearchSchema.defaultFilter"
                        item-text="label"
                        item-value="key"
                        label=""
                        solo
                        ></v-select>
                  </div> -->
                  <div>
                    <div class="margbsm"><span class="common_title">第一维度</span><span>(只选第一维度，x轴是第一维度，y轴是数量)</span></div>
                    <div class="flex_style left margbsm">
                      <div class="common_input_style">
                        <v-select
                            v-model="firstKeyX"
                            :items="sItems"
                            item-text="label"
                            item-value="key"
                            label="分组"
                            @change="handleChange"
                            solo>
                        </v-select>
                      </div>
                       <div class="common_input_style">
                        <v-select
                            v-model="firstKeyY"
                            :items="firstKeyList"
                            item-text="label"
                            item-value="key"
                            label="分组"
                            solo>
                        </v-select>
                      </div>
                    </div>
                    <div class="margbsm"><span class="common_title">分析数量</span><span>（数量越多，可能显示效果越差，请尽量在逻辑表达式上面控制数据范围）</span></div>
                    <div class="common_input_style margbsm">
                      <v-select
                          v-model="firstNum"
                          :items="numList"
                          item-text="label"
                          item-value="key"
                          label=""
                          solo
                          ></v-select>
                    </div>
                  </div>
                  <div>
                    <div class="margbsm"><span class="common_title">第二维度</span><span>(选择两个维度，x轴是第一维度，y轴是数量，平行比较项是第二维度)</span></div>
                    <div class="flex_style left margbsm">
                      <div class="common_input_style">
                        <v-select
                            v-model="secondKeyX"
                            :items="sItems"
                            item-text="label"
                            item-value="key"
                            label="分组"
                            @change="handleChange1"
                            solo>
                        </v-select>
                      </div>
                       <div class="common_input_style">
                        <v-select
                            v-model="secondKeyY"
                            :items="secondKeyList"
                            item-text="label"
                            item-value="key"
                            label="分组"
                            solo>
                        </v-select>
                      </div>
                    </div>
                    <div class="margbsm"><span class="common_title">分析数量</span><span>（数量越多，可能显示效果越差，请尽量在逻辑表达式上面控制数据范围）</span></div>
                    <div class="common_input_style margbsm">
                      <v-select
                          v-model="secondNum"
                          :items="numList"
                          item-text="label"
                          item-value="key"
                          label=""
                          solo
                          ></v-select>
                    </div>
                  </div>
                </div>
            </div>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="handleCustomCancel">
              取消
            </v-btn>
            <v-btn
              color="primary"
              @click="handleCustomOk">
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="itemDialog" width="40%">
        <v-card class="country_dialog">
          <v-card-title class="headline lighten-2">修改自定义分析</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
              <div class="addSpace_wrapper">
                  <div class="padlg">
                      <div class="margbsm"><span class="common_title">名称</span></div>
                      <div class="common_input_style margbsm">
                        <v-text-field
                        label=""
                        hide-details
                        outlined
                        v-model="itemInfo.name"
                        ></v-text-field>
                      </div>
                  </div>
              </div>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="handleItemCancel">
              取消
            </v-btn>
            <v-btn
              color="primary"
              @click="handleItemOk">
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import Vue from 'vue'
export default {
  data() {
    return {
      show: false,
      fcKey: [],
      aggsKey: '',
      slength: {},
      showed: [],
      selectedItem: {},
      saveFilterData: [],
      selectedKey: [],
      selected: [],
      eager: false,
      absolute: false,
      activeKey: '',
      filterKey: "",
      messages: "过滤关键词",
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2,
      },
      index: 0,
      selectKey: [],
      child: false,
      tree: [],
      initiallyOpen: [],
      customDialog: false,
      customName: '',
      firstKeyList: [],
      firstKeyX: '',
      firstKeyY: '',
      secondKeyList: [],
      secondKeyX: '',
      secondKeyY: '',
      numList: [
        {
          'label': '前10',
          'key': '10'
        },
        {
          'label': '前20',
          'key': '20'
        },
        {
          'label': '前30',
          'key': '30'
        },
        {
          'label': '前40',
          'key': '40'
        },
        {
          'label': '前50',
          'key': '50'
        },
      ],
      sItems: [
        {
          'label': '地域',
          'key': 'region'
        },
        {
          'label': '时间',
          'key': 'time'
        },
        {
          'label': '分类号',
          'key': 'category'
        },
        {
          'label': '公司&人',
          'key': 'company'
        },
        {
          'label': '其他',
          'key': 'other'
        }
      ],
      keyItems: [{
        'key': 'region',
        'list': [
          {
            'label': '专利公开国别',
            'key': 'countryCode'
          },
          {
            'label': '申请人国别',
            'key': 'country'
          },
          {
            'label': '申请人省市',
            'key': 'privince'
          },
          {
            'label': '申请人地市',
            'key': 'city'
          }
        ]
      },
      {
        'key': 'time',
        'list': [
          {
            'label': '申请日（年）',
            'key': 'documentYear'
          },
          {
            'label': '申请日（月）',
            'key': 'documentMonth'
          },
          {
            'label': '公布日（年）',
            'key': 'applicationYear'
          },
          {
            'label': '公布日（月）',
            'key': 'applicationMonth'
          }
        ]
      },
      {
        'key': 'category',
        'list': [
          {
            'label': 'IPC分类号',
            'key': 'ipc'
          },
          {
            'label': 'IPC（按部）',
            'key': 'ipc1'
          },
          {
            'label': 'IPC（按大类）',
            'key': 'ipc2'
          },
          {
            'label': 'IPC（按小类）',
            'key': 'ipc3'
          },
          {
            'label': 'IPC（按大组）',
            'key': 'ipc4'
          },
          {
            'label': 'IPC（按小组）',
            'key': 'ipc5'
          }
        ]
      },
      {
        'key': 'company',
        'list': [
          {
            'label': '申请人',
            'key': 'applicant'
          },
          {
            'label': '第一申请人',
            'key': 'firstApplicant'
          },
          {
            'label': '申请人类型',
            'key': 'applicantType'
          },
          {
            'label': '专利权人',
            'key': 'assignee'
          },
          {
            'label': '专利权人类型',
            'key': 'assigneeType'
          },
          {
            'label': '发明人',
            'key': 'inventor'
          },
          {
            'label': '第一发明人',
            'key': 'firstInventor'
          },
          {
            'label': '代理人',
            'key': 'agent'
          },
          {
            'label': '代理机构',
            'key': 'agency'
          }
        ]
      },
      {
        'key': 'other',
        'list': [
          {
            'label': '专利类型',
            'key': 'type'
          },
          {
            'label': '法律状态',
            'key': 'legalStatus'
          },
          {
            'label': '维持年份',
            'key': 'maintainYears'
          },
          {
            'label': '被引用数',
            'key': 'citedCount'
          },
          {
            'label': '引用数',
            'key': 'citingCount'
          },
          {
            'label': '权利要求数',
            'key': 'claimsCount'
          }
        ]
      }
      ],
      sItemGroup: '',
      firstNum: '',
      secondNum: '',
      outLineKey: '',
      itemDialog: false,
      itemInfo: {}
    };
  },
  watch: {
        selected(val) {
            console.log('val', val)
        },
        saveFilterData1(val) {
          this.saveFilterData = val
        },
        keyValue(val) {
          if(this.filterKey != val) {
            this.showed = []
          }
          this.filterKey = val
        },
        slength(val) {
          console.log('dddd', val)
        },
        analyKey(val) {
            if(val[0] == 'outline') {
              this.goOutline()
            }
        }
  },
  created() {
    this.getCusList()
  },
  mounted() {
    if(sessionStorage.getItem('AnalyKey')) {
       this.outLineKey = JSON.parse(sessionStorage.getItem('AnalyKey'))[1].key
       let first = JSON.parse(sessionStorage.getItem('AnalyKey'))[0]
       this.defauleSearchSchema.defaultFilter.forEach((item,index)=>{
         if(item.key == first) {
           this.activeKey = index
         }
       })
    }
  },
  destroyed() {
    sessionStorage.removeItem('AnalyKey')
  },
  methods: {
    ...mapMutations("analy", [
      "upsertSavedSearchSchema",
      "setSavedSearchSchemas",
      "updateDefaultSearchSchema"
    ]),
    ...mapActions('analy',["saveCustomRation","queryCustomList","updateSavedItem"]),
    getCusList() {
      let _this = this
      this.queryCustomList({handle(res) {
      }})
    },
    getNameByKey(key) {
      let totalList = this.totalList
      let name = ''
      totalList.forEach((item)=>{
        if(item.key == key) {
          name = item.label
        }
      })
      return name
    },
    goAnalysis(key1,val) {
      this.outLineKey = val.key
      let data = [key1,val]
      sessionStorage.setItem('AnalyKey', JSON.stringify(data))
      this.$store.commit('setAnalyKey', data)
    },
    goOutline() {
      this.outLineKey = ''
      this.activeKey = ''
      // let data = ['outline',{key: '',label: '概览分析'}]
      // sessionStorage.setItem('AnalyKey', JSON.stringify(data))
      // this.$store.commit('setAnalyKey', data)
    },
    openCustom() {
      this.customDialog = true
    },
    handleCustomOk() {
      let data = {
        params: {
          'name': this.customName,
          'group': 'other' || this.sItemGroup,
          'first': this.firstKeyY,
          'second': this.secondKeyY,
          'firstNum': this.firstNum,
          'secondNum': this.secondNum
        }
      }
      let _this = this
      this.saveCustomRation({data: data,handle(res) {
          if(res.success) {
            _this.$message({
              type: 'success',
              message: res.message
            })
            _this.customDialog = false
            let data = {
              'key': _this.firstKeyY+ '-'+_this.secondKeyY,
              'label': _this.customName,
              'default': 'lineChart'
            }
            _this.goAnalysis('other', data)
            _this.getCusList()
          }else {
            _this.$message({
              type: 'error',
              message: res.message || '操作失败'
            })
          }
      }})
    },
    handleCustomCancel() {
      this.customDialog = false
    },
    handleChange(e) {
      this.keyItems.forEach((item)=>{
        if(item.key == e) {
          this.firstKeyList = item.list
        }
      })
    },
    handleChange1(e) {
      this.keyItems.forEach((item)=>{
        if(item.key == e) {
          this.secondKeyList = item.list
        }
      })
    },
    delItem(val) {
      this.$msgbox.confirm('此操作将永久删除该项目, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
            val.type ='r'
            let data = {
              params: val
            }
            let _this = this
            this.updateSavedItem({data: data,handle(res) {
              if(res.success) {
                _this.getCusList()
                let data = {key: '',label: '概览分析'}
                _this.goAnalysis('outline', data)
              }
            }})
      }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
      });
    },
    editItem(val) {
      this.itemDialog = true
      this.itemInfo = val
    },
    handleItemOk() {
      this.itemInfo.type = 'u'
      let data = {
        params: this.itemInfo
      }
      let _this = this
      this.updateSavedItem({data: data,handle(res) {
        if(res.success) {
          _this.itemDialog = false
          _this.getCusList()
          let data = {
              'key': _this.itemInfo.first+ '-'+_this.itemInfo.second,
              'label': _this.itemInfo.name,
              'default': _this.itemInfo.default
          }
          _this.goAnalysis('other', data)
        }
      }})
    },
    handleItemCancel() {
      this.itemDialog = false
    }
  },
  computed: {
    ...mapGetters("analy", {
      defauleSearchSchema: "defauleSearchSchema",
      savedSearchSchemas: "savedSearchSchemas",
      getSavedSearchSchema: "getSavedSearchSchema",
      loading: state=>state.loadingCount>0?true:false
    }),
    saveFilterData1() {
        return this.$store.state.saveFilterData
    },
    analyKey() {
      return this.$store.state.analyKey
    }
  },
};
</script>